import { AxiosError } from 'axios';

export const isAxiosError = (error: AxiosError | any): error is AxiosError => error.isAxiosError;

export const isNetworkError = (error: AxiosError | any): boolean =>
  isAxiosError(error) && !error.response;
